import { render, staticRenderFns } from "./AddGuideBookBtn.vue?vue&type=template&id=32afc1ca"
import script from "./AddGuideBookBtn.vue?vue&type=script&lang=js"
export * from "./AddGuideBookBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports